import { IAssetTypeImportRequest, IImportPlan, IPreviewRow } from './i-asset-type-import';

export const buildImportRequest = (
  rows: IPreviewRow[],
  plan: IImportPlan,
  dryRun: boolean,
): IAssetTypeImportRequest => ({
  dryRun,
  onDuplicate: 'skip',
  rows: rows.filter((row) => row.status === 'new').map((row) => {
    const properties: Record<string, string> = {};
    plan.propertyColumns.forEach((column, index) => {
      const value = (row.props[index] ?? '').trim();
      if (value !== '') {
        properties[column.name] = value;
      }
    });

    return {
      rowId: row.key,
      code: row.code.trim(),
      description: row.description.trim(),
      properties,
    };
  }),
});
